import React from 'react';
import CardItem from './CardItem';
import './Cards.css';


function LandlordCards() {
    return (
        <div className='container'>
            <h1 className='heading'>Rent out your space <span style={{color: "#51e1e3"}}>stress free</span></h1>
            <p className='heading_paragraph'>Rent out your space with ease in our verified community and let Bubble do the work for you</p>
            <div className='row'>
                <div className='col-md-4 feature-list'>
                    <CardItem v="1" html={<img alt="screened-renters" src='./images/screened-renters.svg' />}
                            head="Screened Renters"
                            text="All our potential renters have been verified and are credible individuals"
                            />
                </div>

                <div className='col-md-4 feature-list'>
                    <CardItem v="1" html={<img alt="earn-money" src='./images/earn-money.svg' />}
                            head="Earn money"
                            text="Make a steady income from your empty space"/>
                </div>

                <div className='col-md-4 feature-list'>
                    <CardItem v="1" html={<img alt="skip-agent" src='./images/skip-agent.svg' />}
                            head="Skip agent and legal hassels"
                            text="List your space and let bubble do the rest"
                            />
                </div>
            </div>
            
            <h1 className='subheader green-text'>How It Works</h1>

            <div className='row'>
                <div className='col-md-4 feature-list-2'>
                    <CardItem html={<h5 className="steptext">Step 1</h5>}
                            head="List your space"
                            text="Fill all the necessary information and get your space verified by our team"
                            />
                </div>

                <div className='col-md-4 feature-list-2'>
                    <CardItem html={<h5 className="steptext">Step 2</h5>}
                            head="Get verified renters"
                            text="Select a potentual renter from our verified community"/>
                </div>

                <div className='col-md-4 feature-list-2'>
                    <CardItem html={<h5 className="steptext">Step 3</h5>}
                            head="Start making money"
                            text="Relax and earn money from he comfort of your home"
                            />
                </div>
            </div>
        </div>
    )
}

export default LandlordCards;
